import WeightInput from './WeightInput';

export default WeightInput;
